import { regionCountryMasterApi } from '@api/region-country-master';
import { useRecentGetter } from '@lib/common';
import { Fab, FormControlLabel, Radio, TextField } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import FilterIcon from '@material-ui/icons/FilterList';
import { Autocomplete } from '@material-ui/lab';
import {
  asRowList,
  MarketOption,
  toOptions,
} from 'pages/company-to-person/c2p-features/markets-responsible-field';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { $in } from '../operators';
import { FilterForm, useFilterFormActions } from './filter-form';

export function MarketsResponsibleFilters(props) {
  const [options, setOptions] = useState<MarketOption[]>([]);
  const [loading, setLoading] = useState(true);
  const { handleSubmit, control } = useForm<{ value: MarketOption[] }>();
  const {
    column: { filterValue, setFilter },
    closeFilter,
  } = props;
  const getFilterValue = useRecentGetter(filterValue);
  const getFilterSetter = useRecentGetter(setFilter);
  const getCloseFilter = useRecentGetter(closeFilter);

  useEffect(() => {
    const subscription = regionCountryMasterApi.filterCatalog().subscribe({
      next: (response: any) => setOptions(toOptions(asRowList(response))),
      error: () => setOptions([]),
      complete: () => setLoading(false),
    });
    return () => subscription.unsubscribe();
  }, []);

  const submit = useMemo(
    () =>
      handleSubmit(values => {
        const selected = values.value || [];
        if (selected.length) {
          getFilterSetter()({
            ...getFilterValue(),
            [$in.key]: selected.map(item => item.name).join(','),
          });
        }
        getCloseFilter()();
      }),
    []
  );

  return (
    <form onSubmit={submit}>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12 }}>
        <Controller
          control={control}
          name="value"
          defaultValue={[]}
          render={({ onChange, value }) => (
            <Autocomplete
              multiple
              filterSelectedOptions
              options={options}
              loading={loading}
              value={value || []}
              getOptionLabel={option => option?.name ?? ''}
              getOptionSelected={(option, selectedOption) =>
                option.name === selectedOption.name && option.type === selectedOption.type
              }
              onChange={(_, data) => onChange(data)}
              style={{ width: 320 }}
              renderOption={option => (
                <span
                  style={{
                    color: option.type === 'region' ? '#5E35B1' : '#2E7D32',
                    fontWeight: 600,
                  }}>
                  {option.name}
                </span>
              )}
              renderInput={params => (
                <TextField
                  {...params}
                  variant="standard"
                  label="Markets"
                  placeholder="Type a region or country"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          )}
        />
        <Fab color="primary" size="small" type="submit">
          <FilterIcon />
        </Fab>
      </div>
    </form>
  );
}

export const MarketsResponsiblePresenceFilters = props => (
  <FilterForm {...props} radioFilters={MarketsResponsiblePresenceItems} />
);

function MarketsResponsiblePresenceItems({ setRadioFilter, radioValue }) {
  const { form } = useFilterFormActions(radioValue, setRadioFilter);
  return (
    <>
      <FormControlLabel
        value="false"
        control={<Radio />}
        label="Yes - Has data"
        name="$empty"
        inputRef={form.register}
      />
      <FormControlLabel
        value="true"
        control={<Radio />}
        label="No - Has no data"
        name="$empty"
        inputRef={form.register}
      />
    </>
  );
}
